import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" data-id="element-131" data-mp="2z5bcytzifl9f">
      <SectionHeading kicker="Frequently asked questions" data-id="element-132" data-mp="3mstcxcsxhpnh">Everything you need to know</SectionHeading>

      <div className="mt-10 space-y-3" data-id="element-133" data-mp="3rrmpn30e5cml">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl border border-petal bg-cream" data-id="element-134" data-mp="3d1yoc1s7mdyv" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink" data-id="element-135" data-mp="3i11i2q2qoxrj">
                {f.q}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-berry transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-136" data-mp="20r8catq9lj8l" />
              </button>
              <AnimatePresence initial={false} data-id="element-137" data-mp="2aicstxvl9c5j">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-138" data-mp="25oib2zzjn793">
                    <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-139" data-mp="2temb6xdiwovc">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <CTAButton label="I'm ready to start today" data-id="element-140" data-mp="z37jib0ycfcy" />
    </Section>;
}